import client from '../plugins/axios'

export default {
    info: async (objNm) => {
        return await client.get(`/admin/info/${objNm}`)
    },
    list: async ({ objNm, page, perpage, search }) => {
        return await client.post(`/admin/list/${objNm}`,
            { page: page, search: search, perpage: perpage })
    },
    get: async ({ objNm, uid }) => {
        return await client.get(`/admin/${objNm}/${uid}`)
    },
    create: async ({ objNm, obj }) => {
        return await client.put(`/admin/${objNm}`, { obj: obj });
    },
    update: async ({ objNm, uid, obj }) => {
        return await client.patch(`/admin/${objNm}/${uid}`, { obj: obj });
    },
    delete: async ({ objNm, uid }) => {
        return await client.delete(`/admin/${objNm}/${uid}`);
    },userList: async ({ page, perpage, search }) => {
      return await client.post(`/admin/list/User`,
        { page: page, search: search, perpage: perpage })
    },

}



// WEBPACK FOOTER //
// ./src/api/admin.js